import { theme } from 'antd';
import React from 'react';

import { Pair } from '../../../types/pair';
import PairCard from './PairCard';

type PairCardListProps = {
  pairs: Pair[];
  highlighted: Set<number>;
  onPairHover: (isHovering: boolean) => void;
};

const PairCardList: React.FC<PairCardListProps> = ({ pairs, highlighted, onPairHover }) => {
  const { token } = theme.useToken();

  if (!pairs.length) {
    return null;
  }

  return (
    <div className="axiom-pair-card-list">
      {pairs.map(pair => (
        <PairCard
          key={pair.id}
          pair={pair}
          highlighted={highlighted.has(pair.id)}
          token={token}
          onHover={onPairHover}
        />
      ))}
    </div>
  );
};

export default PairCardList;
